export const mapPatientsToOptions = (patients = [], isHospitalConnected = false, customerType) =>
	patients.map((patient) => ({
		value: patient._id,
		label: isHospitalConnected && customerType === 'hospital_patient'
			? `${patient.full_name}${patient.health_id ? ` [Health ID: ${patient.health_id}]` : ""}`
			: `${patient.patient_name} (${patient.countryCode} ${patient.phone})`,

		// label: `${patient.patient_name} (${patient.countryCode} ${patient.phone}) ${patient.health_id ? ` [Health ID: ${patient.health_id}]` : ""}`,
		data: patient,
	}));

export const buildPatientOptionLabel = (patient, isHospitalConnected) => {
	if (!patient) return "";

	
	if (isHospitalConnected) {
		const name = patient.full_name || patient.name || patient.patient_name;
		const healthId = patient.health_id;
		// return `${name}${healthId ? ` [Health ID: ${healthId}]` : ""}`;
		return `${name}`;
	}

	const name = patient.full_name || patient.patient_name || patient.name;
	const countryCode = patient.countryCode || patient.phoneCode || "";
	const phone = patient.mobile_number || patient.phone || "";
	return name;
};

